// Ported from packages/desk/src/mobile/AppLibrary.tsx (docs/PLAN-2026-09-21-mobile-os-shell.md, step 4). Same file name and props
// as the desk copy, the dk- prefix renamed rdr-, so a fix in one is a copy in the other. Radar never imports @gamo/desk.
/**
 * The App Library: every app the user may open, in the host's named groups, with a search field at the top. It is
 * the More tile, the swipe up on the home screen and the pull handle above the dock.
 */
import { useId, useState } from "react";
import type { RadarAppDefinition } from "../../apps/registry";
import { AppIcon } from "./AppIcon";
import { libraryGroups, searchApps } from "./layout";
import { Sheet } from "./Sheet";

export function AppLibrary({
  open,
  apps,
  categories,
  onClose,
  onOpen,
  onActions,
}: {
  open: boolean;
  apps: RadarAppDefinition[];
  categories?: string[] | undefined;
  onClose: () => void;
  onOpen: (app: RadarAppDefinition) => void;
  onActions: (app: RadarAppDefinition, anchor: HTMLElement) => void;
}) {
  const titleId = useId();
  const [q, setQ] = useState("");
  const groups = q.trim() ? [{ label: "Results", apps: searchApps(apps, q) }] : libraryGroups(apps, categories);
  const close = () => {
    setQ("");
    onClose();
  };
  return (
    <Sheet
      open={open}
      onClose={close}
      title="All apps"
      titleId={titleId}
      data="library"
      className="rdr-mlib"
      header={
        <input
          className="rdr-msearch-field small"
          type="search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search apps"
          aria-label="Search apps"
          enterKeyHint="search"
        />
      }
    >
      {groups.map((g) =>
        g.apps.length === 0 ? (
          <p key={g.label} className="rdr-mempty">
            No app is called that.
          </p>
        ) : (
          <section key={g.label} className="rdr-mlib-group" aria-label={g.label}>
            <h3 className="rdr-mlib-label">{g.label}</h3>
            <div className="rdr-mlib-grid">
              {g.apps.map((a) => {
                const badge = a.badge?.();
                return (
                  <AppIcon
                    key={a.id}
                    id={a.id}
                    name={a.name}
                    icon={a.icon}
                    badge={badge}
                    accent={Boolean(badge)}
                    onOpen={() => {
                      setQ("");
                      onOpen(a);
                    }}
                    onActions={(el) => onActions(a, el)}
                  />
                );
              })}
            </div>
          </section>
        ),
      )}
    </Sheet>
  );
}
